/**
 * @license Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.donut-graph,
.donut-graph__graph {
  position: absolute;
  width: var(--dashboard-donut-graph-size);
  height: var(--dashboard-donut-graph-size);

  top: 0;
  right: 0;
}

.donut-arc {
  stroke: var(--base-border-color);
  stroke-width: 1px;
}

.donut-arc--pass,
.donut-legend-circle--pass {
  stroke: var(--pass-color);
}

.donut-pattern--pass line {
  stroke: var(--pass-color);
}

.donut-arc--fail,
.donut-legend-circle--fail {
  stroke: var(--fail-color);
}

.donut-pattern--fail line {
  stroke: var(--fail-color);
}

.donut-arc--na,
.donut-legend-circle--na {
  stroke: var(--neutral-highlight-color);
  fill: var(--secondary-background-color);
}

.donut-graph-legend {
  --legend-circle-size: 24px;

  width: 100%;
  padding-top: var(--base-spacing);
  padding-bottom: var(--base-spacing);

  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
}

.donut-graph-legend__label {
  line-height: var(--legend-circle-size);
  margin-left: calc(var(--base-spacing) / 2);
}

.donut-graph-legend__legend-circle {
  margin-left: var(--base-spacing);
  width: var(--legend-circle-size);
  height: var(--legend-circle-size);
}
